package com.patronat.top.features.dashboard.domain.usecase.command

import com.patronat.top.dto.ReviewFilterRequest

data class GetOwnerReviewsCommand(
    val request: ReviewFilterRequest
)
